import { getMomentDate } from '../utils/commonUtils';
import { COLLABORATOR_REPORT, PAGINATION } from '../constants/Define';
import moment from 'moment';
export default class ReportCollaborator {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.pageIndex = data.pageIndex || PAGINATION.pageIndex;
        this.pageSize = data.pageSize || PAGINATION.pageSize;
        this.totalCount = data.totalCount || 0;
        this.totalPage = Math.ceil(parseInt(data.totalCount || 0) / parseInt(2));
        this.startDate = data.startDate ? moment.utc(data.startDate) : '';
        this.endDate = data.startDate ? moment.utc(data.endDate) : '';
        this.orderBy = data.orderBy;
        this.orderByDesc = data.orderByDesc;
        this.items = data.result && data.result.map(item => new ReportCollaboratorItem(item));
    }

}

export class ReportCollaboratorItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id;
        this.name = data.name;
        this.email = data.email;
        this.phoneNumber = data.phoneNumber;
        this.orderId = data.orderId;
        this.customerId = data.customerId;
        this.orderCode = data.orderCode;
        this.arrivalDate = data.arrivalDate;
        this.departureDate = data.departureDate;
        this.orderAmount = data.orderAmount;
        this.orderCumulativeAmount = data.orderCumulativeAmount;
        this.orderCumulativeCode = data.orderCumulativeCode;
        this.checkOutPms = data.checkOutPms;
        this.pmsStatus = data.pmsStatus;
        this.isAccumulated = data.isAccumulated;
        this.itineraryNumber = data.itineraryNumber;
        this.sessionId = data.sessionId;
        this.createdDate = data.createdDate;
        this.createdBy = data.createdBy;
        this.status = COLLABORATOR_REPORT.STATUS.find(e => e.value === data?.status).text || "";
    }
}
